import {setGlobal} from '@netx/core-next/utils/setGlobal';
import Session from '@netx/core/lib/netx-session';

export const session = new Session();

setGlobal({session});

export default session;
